module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_03_1280_1280_ko-d7ee378d330e372bbc65e5a92e764391.jpg";